import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DateTime, { LONG_DATE, SHORT_TIME } from '../DateTime';
import AuctionProgressBar from './AuctionProgressBar';
import { auctionType } from '../../types';
import {
    getUIPhase,
    RUNNING,
} from '../../utils/AuctionPhase';
import './_styles_/AuctionHeaderProgress.css';
import AuctionCountdown from './AuctionCountdown';

AuctionHeaderProgress.propTypes = {
    auction: auctionType.isRequired,
};

function AuctionHeaderProgress(props) {
    const {
        auction,
    } = props;
    const { t } = useTranslation();
    const uiPhase = getUIPhase(auction.phase);
    const isRunning = uiPhase.is(RUNNING);
    const [progress, setProgress] = useState(null);
    const progressText = isRunning ? `${progress} %` : uiPhase.translate(t);
    return (
        <div className="auction-header--progress">
            <div className="auction-header--progress--header">
                <div className="auction-header--progress--header--date-time">
                    <DateTime value={auction.openingTime} format={SHORT_TIME} />
                    <span className="auction-header--progress--header--date-time--date">
                        (<DateTime value={auction.openingTime} format={LONG_DATE} />)
                    </span>
                </div>
                {isRunning && <AuctionCountdown auction={auction} />}
                <div className="auction-header--progress--header--date-time">
                    <DateTime value={auction.closureTime} format={SHORT_TIME} />
                    <span className="auction-header--progress--header--date-time--date">
                        (<DateTime value={auction.closureTime} format={LONG_DATE} />)
                    </span>
                </div>
            </div>
            <div className={`auction-header--progress--bar-container ${uiPhase.id}`} title={progressText}>
                {isRunning && <AuctionProgressBar auction={auction} onProgress={setProgress} />}
            </div>
        </div>
    );
}

export default AuctionHeaderProgress;
